var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.48 4C27.42 4 28.2 4.76 28.2 5.72V42.3C28.2 43.24 27.44 44.02 26.48 44.02C14.7 44.02 6.47998 35.8 6.47998 24.02C6.47998 12.24 14.72 4 26.48 4Z",
    fill: "url(#paint0_linear_150_33008)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.08 23.0801L35.4 17.3801C34.82 16.8001 33.86 16.8001 33.28 17.3801C32.7 17.9601 32.7 18.9201 33.28 19.5001L36.4 22.6201H17.26C16.44 22.6201 15.76 23.3001 15.76 24.1201C15.76 24.9401 16.44 25.6201 17.26 25.6201H36.4L33.28 28.7401C32.7 29.3201 32.7 30.2801 33.28 30.8601C33.58 31.1601 33.96 31.3001 34.34 31.3001C34.72 31.3001 35.1 31.1601 35.4 30.8601L41.08 25.1601C41.66 24.6001 41.66 23.6601 41.08 23.0801Z",
    fill: "url(#paint1_linear_150_33008)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_150_33008",
    x1: -7.60272,
    y1: 51.2614,
    x2: 56.5252,
    y2: 19.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E5774D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#AE02A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1801A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_150_33008",
    x1: -0.938885,
    y1: 33.8975,
    x2: 24.8709,
    y2: -8.23315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E5774D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#AE02A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1801A1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.c59053494fd4234bf1f37f9c225791c6.svg";
export { ForwardRef as ReactComponent };